module.exports = __webpack_public_path__ + "b4dc972fedfad52957324ea7530801ee.svg";